export default {
  MaxNumFile: 5,
  MaxSizeFile: 10, // không cho phép tải file quá 10MB
  maxDurationFile: 60, // Thời lượng của file (giây)
}
